const LearningContentReq = {
    idProfilePemLat: null,
    idSekolah: null,
    idGuru: null,
    kodeCabang: 'HO',
    idKelas: null,
    idKurikulum: 3,
    idTema: null,
    idSubTema: null,
    idPembelajaran: null,
    idMapel: null,
    idBab: null,
    idSubBab: null,
    owner: 'PSEP',
    deleted: 0,
    judul: null,
    idRencana: null,
    tipeKontent: null,
    soal_list: [],
    idMateri: null,
    isiMateri: "",
    idVideo: null,
    linkVideo: "",
    sumber : null
};

export default LearningContentReq;